import React from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components';

const PopularContainer = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Headline = styled.div`
  width: 100%;
  height: 100px;
  background-color: #505BA0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const Heading = styled.h2`
  font-weight: 800;
  font-size: 2.5rem;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

const Card = styled.div`
  width: 18rem;
  padding: 20px;
  border: 2px solid #505BA0;
  border-radius: 10px;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
`;

const PopularText = styled.p`
  margin-bottom: 20px;
`;

const Popular = () => {
  return (
    <PopularContainer>
      <Headline>
        <Heading>
          <span>Popular</span><br />
          <span>Projects</span>
        </Heading>
      </Headline>
      <CardContainer>
        <Card>
          <img
            className="card-img-top"
            src="https://th.bing.com/th/id/OIP.7udy4r-k9TSRRE0EuAJXAQHaHy?rs=1&pid=ImgDetMain"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Simple Calculator</h5>
            <p className="card-text">
              This is simple calculator where we can do simple claculation only.
              created by: <code>Sahil</code>
            </p>
            <Link to="/calc" className="btn btn-primary">
              Visit
            </Link>
          </div>
        </Card>

        <Card>
          <img
            className="card-img-top"
            src="https://yt3.googleusercontent.com/x1Qg8bPhjX_Z6JiJr4vuUAM2vcibYYi3TQy0hnhZvnhfX7vNwczEJAyqUB420AF39WmGaYfpVg=s900-c-k-c0x00ffffff-no-rj"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Anime Versee</h5>
            <p className="card-text">
              This is an Anime website where you can search any anime and get details of it and you can see trailer of it too. Created by: <code>Sahil</code>
            </p>
            <a className="btn btn-primary" href="https://anime-versee.netlify.app/">Visit</a>
          </div>
        </Card>

        <Card>
          <img
            className="card-img-top"
            src="https://th.bing.com/th/id/OIP.-XcFyGduyZipjo221zLzXgHaHa?rs=1&pid=ImgDetMain"
            alt="Not Found"
          />
          <div className="card-body">
            <h5 className="card-title">Bubble Game</h5>
            <p className="card-text">
             This is an Bubble Game where you have 1 minute time and you need to click on hit bubble and if hit bubble an yours clicked bubble match you get 10 point.
              created by: <code>Sahil</code>
            </p>
            <Link to="/bbl" className="btn btn-primary">
              Visit
            </Link>
          </div>
        </Card>
      </CardContainer>
    </PopularContainer>
  );
};

export default Popular;
